import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5199/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// FindHelp Service Functions
export const fetchFindHelpData = async (memberId) => {
  try {
    if (!memberId) {
      throw new Error('Member ID is required');
    }

    const requestBody = {
      MemberIDs: `11-${memberId}`, // Format expected by the API
      StartDate: new Date(new Date().setMonth(new Date().getMonth() - 6)).toISOString(), // 6 months ago
      EndDate: new Date().toISOString() // Today
    };

    const response = await apiClient.post(`/findhelp/referral-status`, requestBody);
    return response.data;
  } catch (error) {
    console.error('Error fetching findhelp data:', error);
    throw new Error('Failed to fetch findhelp data');
  }
};

export const fetchReferralStatusGrid = async (params) => {
  try {
    // Ensure externalUserId, userType, and cardGuid are first in the params object
    const orderedParams = {
      externalUserId: params.externalUserId,
      userType: params.userType,
      cardGuid: params.cardGuid,
      ...params
    };
    const response = await apiClient.post(`/findhelp/grid-model`, orderedParams);
    return response.data;
  } catch (error) {
    console.error('Error fetching referral status grid:', error);
    throw new Error('Failed to fetch referral status grid');
  }
};



